import React from 'react';

import {Helmet, useParams} from 'views/module';

import DomainGuideViewScene from 'views/scenes/domain_guide/detail/DomainGuideView';

const DomainGuideView = (props) => {
  const params = useParams();
  const domainGuideRn = params.domainGuideRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Domain Guide Details</title>
      </Helmet>
      <DomainGuideViewScene domainGuideRn={domainGuideRn} />
    </>
  );
};

export default DomainGuideView;
